import { FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    ID_UPLOAD_RESET_VALUE,
    ID_UPLOAD_SET_VALUE,
    ID_UPLOAD_SET_VALID,
    KRA_PIN_UPLOAD_SET_VALUE,
    KRA_PIN_UPLOAD_RESET_VALUE,
    KRA_PIN_UPLOAD_SET_VALID,
    FORM_VALID_AFYA_IMARA_DOCUMENTS_FORM,
    FORM_INVALID_AFYA_IMARA_DOCUMENTS_FORM,
    BIRTH_CERTIFICATE_SET_VALUE,
    BIRTH_CERTIFICATE_SET_VALID,
    BIRTH_CERTIFICATE_RESET_VALUE,
    SPOUSE_ID_SET_VALUE,
    SPOUSE_ID_SET_VALID,
    SPOUSE_ID_RESET_VALUE,
    PERSONAL_VALID_SET_VALUE,
    CHILDREN_VALID_SET_VALUE,
    SPOUSE_VALID_SET_VALUE,
} from '../../actions/afyaImara/Documents';

export const initDocuments = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    personalDetailsValid: false,
    childDetailsDocuments: [],
    spouseDetailsValid: false,
    form: {
        //new
        idUpload: { value: null, error: null, status: null },
        kraPinUpload: { value: null, error: null, status: null },
        spouseId: { value: null, error: null, status: null },
    },
};

export default (state = initDocuments, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_AFYA_IMARA_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_AFYA_IMARA_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case PERSONAL_VALID_SET_VALUE:
            return { ...state, personalDetailsValid: action.value };

        case CHILDREN_VALID_SET_VALUE:
            return { ...state, childDetailsDocuments: action.value };

        case SPOUSE_VALID_SET_VALUE:
            return { ...state, spouseDetailsValid: action.value };

        // ID UPLOAD

        case ID_UPLOAD_SET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_UPLOAD_SET_VALID:
            return updateFormField('idUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_UPLOAD_RESET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: null,
                status: null,
            }));

        // KRA PIN UPLOAD
        case KRA_PIN_UPLOAD_SET_VALUE:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                value: action.value,
            }));

        case KRA_PIN_UPLOAD_SET_VALID:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_PIN_UPLOAD_RESET_VALUE:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                value: null,
                status: null,
            }));

        case SPOUSE_ID_SET_VALUE:
            return updateFormField('spouseId', (field) => ({
                ...field,
                value: action.value,
            }));

        case SPOUSE_ID_SET_VALID:
            return updateFormField('spouseId', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SPOUSE_ID_RESET_VALUE:
            return updateFormField('spouseId', (field) => ({
                ...field,
                value: null,
                status: null,
            }));

        // Reset the state
        case REINITIALIZE:
            return initDocuments;
        default:
            return state;
    }
};
